import { Button, Card, Input, Label } from "@repo/ui";
import { useEffect, useState } from "react";

type NewsCategory = {
  id: number;
  name: string;
  slug: string;
  created_at: string;
};

export default function AdminNewsCategories() {
  const [list, setList] = useState<NewsCategory[]>([]);
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [saving, setSaving] = useState(false);

  async function load() {
    const res = await fetch("/api/admin/news-categories");
    const data = (await res.json()) as { status: string; data: NewsCategory[] };
    setList(data.data || []);
  }

  useEffect(() => {
    void load();
  }, []);

  async function create(e: React.FormEvent) {
    e.preventDefault();
    if (!name.trim()) return;
    setSaving(true);
    await fetch("/api/admin/news-categories", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name, slug: slug || undefined }),
    });
    setSaving(false);
    setName("");
    setSlug("");
    void load();
  }

  async function remove(id: number) {
    if (!confirm("ลบหมวดหมู่นี้หรือไม่?")) return;
    await fetch(`/api/admin/news-categories/${id}`, { method: "DELETE" });
    setList((prev) => prev.filter((x) => x.id !== id));
  }

  return (
    <div className="space-y-6 max-w-3xl">
      <h1 className="font-display text-3xl">หมวดหมู่ข่าวสาร</h1>
      <Card className="p-4 bg-card/60">
        <form onSubmit={create} className="grid gap-3 md:grid-cols-[2fr_2fr_auto] items-end">
          <div className="grid gap-1">
            <Label htmlFor="name">ชื่อหมวดหมู่</Label>
            <Input
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="เช่น ข่าวดวงรายวัน"
              required
            />
          </div>
          <div className="grid gap-1">
            <Label htmlFor="slug">Slug (ไม่ใส่ก็ได้)</Label>
            <Input
              id="slug"
              value={slug}
              onChange={(e) => setSlug(e.target.value)}
              placeholder="เช่น daily-news"
            />
          </div>
          <Button type="submit" disabled={saving}>
            {saving ? "กำลังบันทึก..." : "เพิ่มหมวดหมู่"}
          </Button>
        </form>
      </Card>
      <Card className="p-4 bg-card/60">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-left text-foreground/70">
              <tr>
                <th className="py-2 pr-2">ชื่อหมวดหมู่</th>
                <th className="py-2 pr-2">Slug</th>
                <th className="py-2 pr-2">สร้างเมื่อ</th>
                <th className="py-2 pr-2 text-right">จัดการ</th>
              </tr>
            </thead>
            <tbody>
              {list.map((c) => (
                <tr key={c.id} className="border-t border-border/60">
                  <td className="py-2 pr-2 font-medium">{c.name}</td>
                  <td className="py-2 pr-2 text-foreground/70">{c.slug}</td>
                  <td className="py-2 pr-2 text-foreground/70">
                    {new Date(c.created_at).toLocaleDateString("th-TH")}
                  </td>
                  <td className="py-2 pr-2 text-right">
                    <Button type="button" variant="outline" size="sm" onClick={() => remove(c.id)}>
                      ลบ
                    </Button>
                  </td>
                </tr>
              ))}
              {list.length === 0 && (
                <tr>
                  <td className="py-4 text-center text-foreground/60" colSpan={4}>
                    ยังไม่มีหมวดหมู่ข่าวสาร
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
